import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import QRCodeStyling from "qr-code-styling";

export default function QRCodeModal({ hideQRCode, defaultLink, onSave }) {

    const qrCodeRef = useRef(null);
    const [inputValue, setInputValue] = useState(defaultLink || '');
    const [width, setWidth] = useState(300);
    const [height, setHeight] = useState(300);
    const [margin, setMargin] = useState(20);
    const [image, setImage] = useState('');
    const [color, setColor] = useState('#541D94');
    const [cornersSquareColor, setCornersSquareColor] = useState('#541D94');
    const [cornersDotColor, setCornersDotColor] = useState('#541D94');
    const [shapeType, setShapeType] = useState('circle');
    const [dotsShape, setDotsShape] = useState('extra-rounded');
    const [dotsColor, setDotsColor] = useState('#541D94');
    const [backgroundColor, setBackgroundColor] = useState('#ffffff');
    const [qrCode, setQrCode] = useState(null);

    useEffect(() => {
        setQrCode(new QRCodeStyling({
            width,
            height,
            data: inputValue,
            image,
            margin,
            shapeType: shapeType,
            dotsOptions: {
                color: dotsColor,
                type: dotsShape
            },
            backgroundOptions: {
                color: backgroundColor,
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 20
            },
            cornersSquareOptions: {
                color: cornersSquareColor,
            },
            cornersDotOptionsHelper: {
                color: cornersDotColor,
            }
        }));
    }, []);

    useEffect(() => {
        if (qrCode) {
            qrCode.append(qrCodeRef.current);
        }
    }, [qrCode]);

    const handleChange = e => {
        setInputValue(e.target.value);
        qrCode.update({
            data: e.target.value
        });
    }

    const handleColorChange = e => {
        setColor(e.target.value);
        qrCode.update({
            dotsOptions: { color: e.target.value },
            cornersSquareOptions: { color: e.target.value },
            cornersDotOptionsHelper: { color: e.target.value },
        });
    }

    const handleBgColorChange = e => {
        setBackgroundColor(e.target.value);
        qrCode.update({
            backgroundOptions: { color: e.target.value }
        });
    }

    const handleImageChange = e => {
        setImage(e.target.value);
        qrCode.update({
            image: e.target.value
        });
    }

    const handleWidthChange = e => {
        setWidth(e.target.value);
        qrCode.update({
            width: e.target.value
        });
    }

    const handleHeightChange = e => {
        setHeight(e.target.value);
        qrCode.update({
            height: e.target.value
        });
    }

    const handleMarginChange = e => {
        setMargin(e.target.value);
        qrCode.update({
            margin: e.target.value
        });
    }

    const handleShapeTypeChange = e => {
        setShapeType(e.target.value);
        qrCode.update({
            shapeType: e.target.value
        });
    }

    const handleDotsShapeChange = e => {
        setDotsShape(e.target.value);
        qrCode.update({
            dotsOptions: { type: e.target.value }
        });
    }

    const handleDownload = () => {
        qrCode.download({ extension: "png" });
    }

    const handleSave = () => {
        onSave(qrCode);
        hideQRCode();
    }


    return (
        <div className="wrapper">
            <div className="modal">
                <div className="header">
                    <h2>Generate QR Code</h2>
                    <div className="cancel" onClick={hideQRCode}>
                        <Cancel />
                        Close
                    </div>
                </div>
    
                <div className="flex_top qr-form">
                    <div>
                        <label className="label">Input for QR Code</label>
                        <input
                            type="text"
                            value={inputValue}
                            onChange={handleChange}
                        />
    
                        <label className="label">Color</label>
                        <input
                            type="color"
                            value={color}
                            onChange={handleColorChange}
                        />
    
                        <label className="label">Background Color</label>
                        <input
                            type="color"
                            value={backgroundColor}
                            onChange={handleBgColorChange}
                        />
    
                        <label className="label">Margin</label>
                        <input
                            type="number"
                            value={margin}
                            onChange={handleMarginChange}
                        />
    
                        <label className="label">Width</label>
                        <input
                            type="number"
                            value={width}
                            onChange={handleWidthChange}
                        />
    
                        <label className="label">Height</label>
                        <input
                            type="number"
                            value={height}
                            onChange={handleHeightChange}
                        />
                    </div>
    
                    <div>
                        <label className="label">Shape Type</label>
                        <select value={shapeType} onChange={handleShapeTypeChange}>
                            <option value="circle">Circle</option>
                            <option value="square">Square</option>
                            {/* add more options if necessary */}
                        </select>
    
                        <label className="label">Dot Shape</label>
                        <select value={dotsShape} onChange={handleDotsShapeChange}>
                            <option value="extra-rounded">Extra Rounded</option>
                            <option value="rounded">Rounded</option>
                            <option value="square">Square</option>
                            {/* add more options if necessary */}
                        </select>
    
                        <label className="label">Image URL</label>
                        <input
                            type="text"
                            value={image}
                            onChange={handleImageChange}
                            placeholder="http://example.com/logo.png"
                        />
                    </div>
                </div>
    
                <div className="qr-code-container" ref={qrCodeRef}></div>
    
                <div className="button-container">
                    <button onClick={handleDownload}>Download</button>
                    <button onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    )
        
}
